$(document).ready(function () {
    let parentEle = $('body');
    fun = {
        headerAnimation() {
            const height = $(window).height();
            const headerHeight = $('.appHeader').outerHeight();

            $(document).scroll(() => {
                // const bannerHeight = Math.round(($('.homeBanner').outerHeight()) - headerHeight) ||
                //     Math.round(($('.pageBanner').outerHeight()) - headerHeight);
                const bannerHeight = 150;
                const top = $(document).scrollTop();
                if (top > bannerHeight) {
                    $('.appHeader').addClass('animate');
                } else {
                    $('.appHeader').removeClass('animate');
                }
            })
        },
        appMenu() {
            parentEle.on('mouseover', '.appNav nav > a.parentMenu', function (e) {
                e.stopPropagation();
                const id = $(this).attr('id');
                $('.appNav .menuBox .menuContent').removeClass('active');
                $('.appNav .menuBox').addClass('show');

                const menuBox = $('.'+id);
                menuBox.addClass('active');

                $('.menuBox').css({
                    width: menuBox.outerWidth() + 'px',
                    height: menuBox.outerHeight() + 'px',
                });

                const menuLeftVal = $(this).position().left;
                const menuWidth = $(this).outerWidth();
                const menuBoxWidth = menuBox.outerWidth();
                const navWidth = $('.appNav').width();

                const leftVal = Math.round(((menuBoxWidth - navWidth) / 2) + (menuLeftVal +(menuWidth / 2))) - 6;

                $('.menuBoxContent .navArrow').css({
                    left: leftVal + 'px'
                });

            });
            parentEle.on('mouseover', '.appNav .menuBox', function (e) {
                e.stopPropagation();
            });
            parentEle.on('click', '.appNav .menuBox .content a', function (e) {
                $('.appNav .menuBox').removeClass('show');
            });

            $(document).mouseover(function (e) {
                $('.appNav .menuBox').removeClass('show');
            })


            parentEle.on('click', '.appMenuBtn', function (e) {
                if ($(this).hasClass('animate')) {
                    $(this).removeClass('animate');
                    $('.menuSec').removeClass('show');
                    $('header').removeClass('black');
                } else{
                    $(this).addClass('animate');
                    $('.menuSec').addClass('show');
                    $('header').addClass('black');
                }
            });
            parentEle.on('click', '.menuSec .menuCont .menuList li a, header .logoMain', function (e) {
                $('.appMenuBtn').removeClass('animate');
                $('.menuSec').removeClass('show');
                $('header').removeClass('black');
            });
        },
       preventDefaultClicks: function () {
          let selectors = 'header .subNav a';
          parentEle.on('click', selectors, function (e) {
             e.stopImmediatePropagation();
             e.stopPropagation();
          });
       },
        initFunc() {
            this.headerAnimation();
            this.appMenu();
            this.preventDefaultClicks();
        }
    }

    fun.initFunc();


   // var scrollBefore = 0;
   //
   // $(window).scroll(function(e){
   //    const scrolled = window.scrollY;
   //
   //    if(scrollBefore > scrolled){
   //       console.log("ScrollUP");
   //       scrollBefore = scrolled;
   //       //Desired action
   //    }else{
   //       scrollBefore = scrolled;
   //       console.log("ScrollDOWN");
   //       //Desired action
   //    }
   //
   //    console.log($(window).scrollTop())
   //    console.log($('.sliderSec').offset().top)
   //
   //    if ($(window).scrollTop() > $('.sliderSec').offset().top) {
   //       $('body').animate({ scrollTop: $('.sliderSec').offset().top }, 0);
   //    }
   //
   // })
});
